import React from 'react'

const InfoForDietitian = ({
  label,
  data,
  suffix,
  border = true
}: {
  label: string
  data: string | boolean | number
  suffix?: string
  border?: boolean
}) => {
  return (
    <div
      className={`flex flex-col md:flex-row items-start md:items-center gap-x-2 pb-1 mb-1 ${border ? 'border-b-2 dark:border-gray-600' : ''}`}
    >
      <p className="w-80 flex-shrink-0">{label}</p>
      <p className="w-full font-bold text-blue-800 dark:text-blue-300 break-words text-right md:text-left">
        {data}
        {suffix && <span>{suffix}</span>}
      </p>
    </div>
  )
}

export default InfoForDietitian
